import React, { useState } from "react";
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Paper,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/system";

const CustomSelect = styled(Select)({
  backgroundColor: "#fff",
  borderRadius: "6px",
  fontWeight: "400",
  fontSize: "14px",
  lineHeight: "24px",
  height: "40px",
  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
  },
});

const CustomMenuItem = styled(MenuItem)({
  fontSize: "14px",
  padding: "12px 16px",
});

interface RequiredProps {
  handleChange: (data: any) => void;
  children?: React.ReactNode;
  selectedValue: any;
  name: string;
  options: any;
  title?: any;
}
const TenantDropdownMenu = ({
  title,
  name,
  selectedValue,
  children,
  handleChange,
  options,
}: RequiredProps) => {
  return (
    <Box sx={{ minWidth: 200, m: 0.5 }}>
      <FormControl fullWidth>
        <InputLabel  shrink >{title}</InputLabel>
        <CustomSelect
          fullWidth        
          label={title}
          defaultValue={selectedValue}
          name={name}
          value={selectedValue}
          onChange={(e: any) => handleChange(e)}
          IconComponent={ExpandMoreIcon}
          renderValue={(selected: any) => {
            if (
              !selected ||
              (Array.isArray(selected) && selected.length === 0)
            ) {
              return title;
            }
            return (
              options.find((item: any) => item.tenantId === selected)?.tenant_name ||
              title
            );
          }}
        >
          {options.map((item: any) => {
            return (
              <CustomMenuItem key={item.tenantId} value={item.tenantId}>
                {item.tenant_name}
              </CustomMenuItem>
            );
          })}
        </CustomSelect>
      </FormControl>
      <Paper
        elevation={4}
        sx={{
          mt: 1,
          borderRadius: "10px",
          overflow: "hidden",
          width: "100%",
        }}
      />
    </Box>
  );
};

export default TenantDropdownMenu;
